import { useEffect } from 'react'
import {
  StatsigProvider as SP,
  useClientAsyncInit
} from '@statsig/react-bindings'
import { StatsigAutoCapturePlugin } from '@statsig/web-analytics'
import { StatsigSessionReplayPlugin } from '@statsig/session-replay'

import { useAuth } from './AuthContext'

import Loading from '@/components/Loading'

interface StatsigProviderProps {
  children: React.ReactNode
}

const STAGES = {
  dev: 'development',
  stag: 'staging',
  prod: 'production'
}

export function StatsigProvider({ children }: StatsigProviderProps) {
  const { user } = useAuth()

  const { client, isLoading } = useClientAsyncInit(
    process.env.STATSIG_CLIENT_KEY,
    { userID: user.idCognito },
    {
      environment: { tier: STAGES[process.env.STAGE] },
      plugins: [
        new StatsigAutoCapturePlugin(),
        new StatsigSessionReplayPlugin()
      ]
    }
  )

  useEffect(() => {
    if (!!user && client.getContext().user.userID !== user.idCognito) {
      client.updateUserAsync({ userID: user.idCognito })
    }
  }, [user, client])

  if (isLoading) return <Loading />

  return <SP client={client}>{children}</SP>
}
